import { render, staticRenderFns } from "./CourierLimitMasterItem.vue?vue&type=template&id=72e53076&scoped=true"
import script from "./CourierLimitMasterItem.vue?vue&type=script&lang=js"
export * from "./CourierLimitMasterItem.vue?vue&type=script&lang=js"
import style0 from "./CourierLimitMasterItem.vue?vue&type=style&index=0&id=72e53076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e53076",
  null
  
)

export default component.exports